import React, { useEffect } from 'react';
import { BrandLogo } from '../../components/BrandLogo';
import './publico.css';

/** Marco de las páginas públicas del calendario: fondo, tarjeta central y pie con la marca. */
export default function MarcoPublico({ titulo, children, ancho = 'normal', color }) {
  useEffect(() => { if (titulo) document.title = `${titulo} · Orvian`; }, [titulo]);
  return (
    <div className={`pub-fondo pub-fondo--${ancho}`} style={color ? { '--pub-acento': color } : undefined}>
      <main className="pub-tarjeta">{children}</main>
      <footer className="pub-pie">
        <span>Con la tecnología de</span>
        <BrandLogo showText className="pub-marca" />
      </footer>
    </div>
  );
}

export function Cargando() {
  return <div className="pub-cargando"><span className="pub-giro" aria-hidden="true" /> Cargando…</div>;
}

export function Aviso({ titulo, texto, icono }) {
  return (
    <div className="pub-aviso">
      {icono}
      <h1>{titulo}</h1>
      {texto && <p>{texto}</p>}
    </div>
  );
}
